import { useGetTeam } from "@/hooks/queryHooks/teamHooks";
import { useTenantStore } from "@/stores/tenantStore";
import { PDFViewer } from "@react-pdf/renderer";
import type { Meeting } from "@repo/types";
import { MeetingMinutesDocument } from "@repo/ui/components/Base/MeetingMinutesDocument";

export const MeetingMinutesPreview = ({ meeting }: { meeting: Meeting }) => {
  const tenantId = useTenantStore((s) => s.id);
  const { data: team } = useGetTeam(tenantId, meeting.teamId ?? "");

  if (!team) return null;

  return (
    <PDFViewer className="w-full h-full">
      <MeetingMinutesDocument
        meeting={meeting}
        team={team}
        letterHead={
          meeting.letterHead ?? meeting.agenda?.letterHead ?? undefined
        }
      />
    </PDFViewer>
  );
};
